import React, { Component } from "react";
import { loading, tokens, GET } from "../components/CustomComponent.js";
import ProductCard from "../components/ProductCard.js";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import NavbarPublic from "../components/NavbarPublic.js";
import Footer from "../components/Footer.js";

import heroCargo from "../assets/images/hero-cargo.jpg";
import warehouseImg from "../assets/images/warehouse.jpg";
import appShowcase from "../assets/images/app-showcase.jpg";

class Index extends Component {
  async componentDidMount() {
    loading(false);

    if (tokens) {
      const result = await GET("v1/admin/users/profile");
      if (result?.status) {
        window.location.href = `/main`;
        return;
      }
    }
  }
  render() {
    return (
      <div className="overflow-hidden">
        <NavbarPublic />
        {this.hero()}
        {this.stats()}
        {/* {this.platforms()} */}
        {this.features()}
        {this.howItWorks()}
        {/* {this.shipping()} */}
        {this.about()}
        {this.testimonials()}
        {this.faq()}
        {this.contact()}
        {this.cta()}
        <Footer />
      </div>
    );
  }

  hero() {
    return (
      <section
        id="index"
        className="hero-section text-white d-flex align-items-center fade-in"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,.7), rgba(0,0,0,.6)), url(${heroCargo})`,
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 slide-up">
              <span className="badge bg-orange text-dark mb-3">
                โปรโมชั่นพิเศษ! ทดลองสั่งเริ่มแค่ 1 บาท
              </span>
              <h1 className="display-4 fw-bold">
                รับนำเข้าสินค้า
                <br />
                <span className="text-orange">จากประเทศจีน</span>
                <br />
                <small className="fs-3">ไม่มีขั้นต่ำ</small>
              </h1>
              <p className="lead mt-3">
                ผู้เชี่ยวชาญด้านการนำเข้าสินค้าจากจีนกว่า 8 ปี
              </p>
              <div className="d-flex gap-3 mt-4">
                <Link to="/login" className="btn bg-orange btn-lg">
                  เริ่มสั่งสินค้าเลย
                </Link>
                {/* <Link to="/#rate" className="btn btn-outline-light btn-lg">
									ดูอัตราค่าขนส่ง
								</Link> */}
                {/* <a
  href="#rate"
  onClick={(e) => {
    e.preventDefault();
    document.getElementById("rate")?.scrollIntoView({
      behavior: "smooth",
    });
  }}
  className="btn btn-outline-light btn-lg"
>
  ดูอัตราค่าขนส่ง
</a> */}
              </div>
            </div>

            <div className="col-lg-6 d-none d-lg-block text-center slide-left">
              <img
                src={appShowcase}
                className="img-fluid rounded shadow-lg rounded-5"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  stats() {
    const stats = [
      { label: "ลูกค้าที่ไว้วางใจ", value: "10,000+" },
      { label: "สินค้าที่นำเข้าแล้ว", value: "50,000+" },
      { label: "ปีประสบการณ์", value: "8+" },
      { label: "ความพึงพอใจ", value: "99%" },
    ];

    return (
      <section className="bg-orange py-4 text-dark">
        <div className="container">
          <div className="row text-center">
            {stats.map((s, i) => (
              <div key={i} className="col-6 col-md-3 zoom-in">
                <h3 className="fw-bold">{s.value}</h3>
                <p>{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  platforms() {
    const partners = [
      "Taobao",
      "1688",
      "Tmall",
      "Pinduoduo",
      "JD",
      "AliExpress",
    ];
    return (
      <section className="py-3 bg-light">
        <div className="container text-center">
          <span className="text-muted me-3">รองรับแพลตฟอร์ม:</span>
          {partners.map((p, i) => (
            <span key={i} className="mx-2 fw-bold text-secondary fade-in">
              {p}
            </span>
          ))}
        </div>
      </section>
    );
  }

  features() {
    const features = [
      { title: "ไม่มีขั้นต่ำ", detail: "เริ่มต้นเพียง 1 ชิ้น", icon: "\uf466" },
      { title: "จัดส่งรวดเร็ว", detail: "7-24 วันถึงไทย", icon: "\uf0d1" },
      { title: "ปลอดภัย 100%", detail: "ประกันสินค้า", icon: "\uf132" },
      { title: "บริการ 24 ชม.", detail: "ทีมงานพร้อมดูแล", icon: "\uf017" },
      {
        title: "ครอบคลุมทุกแพลตฟอร์ม",
        detail: "รองรับสินค้าหลากหลายแหล่ง",
        icon: "\uf0ac",
      },
      { title: "ราคาถูกที่สุด", detail: "ประหยัดกว่าตลาด", icon: "\uf0e7" },
    ];

    return (
      <section className="py-5">
        <div className="container">
          <h2 className="text-center fw-bold mb-3">
            บริการที่ <span className="text-orange">ครบวงจร</span> ที่สุด
          </h2>
          <h5 className="text-secondary text-center mb-5">
            เราให้บริการนำเข้าสินค้าจากจีนแบบครบวงจร
            ตั้งแต่จัดซื้อจนถึงส่งถึงมือคุณ ด้วยประสบการณ์กว่า 8 ปี
          </h5>
          <div className="row g-4">
            {features.map((f, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4 slide-up">
                <div className="bg-light h-100 shadow-sm p-4 rounded-4 border-0 d-flex align-items-center">
                  <div className="wpx-50 hpx-50 bg-orange rounded-4 d-flex align-items-center justify-content-center">
                    <h4 className="text-white fw-bold icon">{f.icon}</h4>
                  </div>
                  <div className="px-3">
                    <h5 className="fw-bold">{f.title}</h5>
                    <p className="text-muted mb-0">{f.detail}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  howItWorks() {
    const steps = [
      {
        title: "เลือกสินค้า",
        detail: "เลือกสินค้าจากเว็บไซต์ของเรา",
        icon: "\uf002",
      },
      {
        title: "สั่งซื้อ",
        detail: "เพิ่มลงตะกร้าและยืนยันคำสั่งซื้อ",
        icon: "\uf218",
      },
      { title: "ชำระเงิน", detail: "ชำระเงินผ่าน QRCode", icon: "\uf555" },
      {
        title: "รอรับสินค้า",
        detail: "ติดตามสถานะแล้วรอรับสินค้าที่บ้าน",
        icon: "\uf0d1",
      },
    ];
    return (
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold mb-3">
            สั่งสินค้าจากจีน <span className="px-1 text-orange">4 ขั้นตอน</span>
          </h2>
          <h5 className="text-secondary text-center mb-5">
            เพียงไม่กี่คลิก สินค้าจากจีนก็ถึงมือคุณ
          </h5>
          <div className="row text-center">
            {steps.map((s, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-3 slide-up">
                <div className="wpx-80 hpx-80 bg-orange rounded-4 d-flex align-items-center justify-content-center mx-auto mb-3 position-relative">
                  <div
                    className="position-absolute wpx-30 hpx-30 rounded-circle bg-dark text-light d-flex align-items-center justify-content-center"
                    style={{ top: -8, right: -12 }}
                  >
                    {i + 1}
                  </div>
                  <h2 className="text-white fw-bold icon">{s.icon}</h2>
                </div>
                <h5 className="fw-bold">{s.title}</h5>
                <span className="text-secondary">{s.detail}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  shipping() {
    const options = [
      {
        title: "ทางเรือ",
        day: "15-25 วัน",
        price: "เริ่ม 15 ฿/kg",
        color: "bg-primary",
        icon: "\uf21a",
      },
      {
        title: "ทางรถ",
        day: "7-12 วัน",
        price: "เริ่ม 28 ฿/kg",
        color: "bg-success",
        icon: "\uf0d1",
      },
      {
        title: "เครื่องบิน",
        day: "3-5 วัน",
        price: "เริ่ม 80 ฿/kg",
        color: "bg-orange",
        icon: "\uf072",
      },
    ];

    return (
      <section className="py-5" id="rate">
        <div className="container">
          <h2 className="text-center fw-bold mb-5">
            เลือก <span className="px-1 text-orange">ขนส่ง</span> ที่เหมาะกับคุณ
          </h2>
          <div className="row g-4">
            {options.map((o, i) => (
              <div key={i} className="col-md-4 zoom-in">
                <div className="bg-white text-center shadow rounded-4 overflow-hidden">
                  <div className={"w-100 py-5 px-4 text-center " + o.color}>
                    <h1 className="text-white fw-bold icon mb-3">{o.icon}</h1>
                    <h2 className="text-white fw-bold">{o.title}</h2>
                  </div>
                  <div className="p-4">
                    <div className="text-secondary">ระยะเวลา</div>
                    <h5 className="fw-bold text-dark mb-4">{o.day}</h5>
                    <div className="text-secondary">ราคา</div>
                    <h5 className="fw-bold text-orange">{o.price}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  about() {
    return (
      <section className="py-5 bg-dark text-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 slide-left mb-3">
              <img src={warehouseImg} className="img-fluid rounded-5 shadow" />
            </div>
            <div className="col-lg-6 slide-right px-5">
              <h1 className="fw-bold mb-3">ผู้นำด้านการนำเข้าสินค้าจากจีน</h1>
              <p>
                Zenith Cargo
                ก่อตั้งขึ้นเพื่อให้คนไทยเข้าถึงสินค้าจากจีนได้ง่ายและราคาถูกที่สุด
                ด้วยคลังสินค้าในกวางโจวและระบบขนส่งที่มีประสิทธิภาพ
                เราการันตีว่าคุณจะได้สินค้าที่ดีที่สุดในราคาที่ดีที่สุด
              </p>
              <ul>
                <li className="mb-4">คลังสินค้าขนาดใหญ่ในจีน</li>
                <li className="mb-4">ทีมงานจัดซื้อมืออาชีพ</li>
                <li className="mb-4">ระบบตรวจสอบคุณภาพก่อนจัดส่ง (QC)</li>
                <li className="mb-4">ประกันสินค้าเสียหาย คืนเงิน 100%</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }

  testimonials() {
    const reviews = [
      {
        name: "คุณสมศรี",
        position: "เจ้าของร้านออนไลน์",
        review:
          "ใช้บริการมา 3 ปีแล้ว สินค้าถึงเร็ว ราคาดี ทีมงานดูแลดีมาก แนะนำเลยค่ะ",
      },
      {
        name: "คุณวิชัย",
        position: "ผู้ประกอบการ SME",
        review:
          "นำเข้าสินค้าล็อตใหญ่ ราคาถูกกว่าที่อื่นเยอะ บริการหลังการขายดีมากครับ",
      },
      {
        name: "คุณพิมพ์",
        position: "ขายของ Platform Online",
        review:
          "ค่าขนส่งถูก จัดส่งตรงเวลา สินค้าไม่เสียหาย ใช้บริการมาหลายครั้งแล้วค่ะ",
      },
    ];

    return (
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold mb-4">รีวิวลูกค้า</h2>
          <div className="row g-4">
            {reviews.map((r, i) => (
              <div
                key={i}
                className="col-12 col-lg-4 slide-up"
                style={{ minHeight: "100%" }}
              >
                <div
                  className="bg-white p-4 shadow-sm rounded-4"
                  style={{ minHeight: "100%" }}
                >
                  <div className="d-flex mb-3">
                    <div className="icon text-orange me-1">{"\uf005"}</div>
                    <div className="icon text-orange me-1">{"\uf005"}</div>
                    <div className="icon text-orange me-1">{"\uf005"}</div>
                    <div className="icon text-orange me-1">{"\uf005"}</div>
                    <div className="icon text-orange me-1">{"\uf005"}</div>
                  </div>
                  <div className="mb-4">"{r.review}"</div>
                  <div className="d-flex">
                    <div className="wpx-50 hpx-50 bg-orange rounded-circle d-flex align-items-center justify-content-center fw-bold text-20 text-light">
                      {r.name.replaceAll("คุณ", "").slice(0, 1)}
                    </div>
                    <div className="px-3 w-100">
                      <strong>{r.name}</strong>
                      <div className="text-secondary w-100">{r.position}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  faq() {
    const faq = [
      {
        q: "สั่งสินค้าขั้นต่ำกี่ชิ้น?",
        a: "ไม่มีขั้นต่ำ! สั่งเริ่มต้นเพียง 1 ชิ้นก็ได้ เราไม่จำกัดจำนวน",
      },
      {
        q: "ใช้เวลาจัดส่งกี่วัน?",
        a: "โดยปกติใช้เวลาจัดส่งประมาณ 7-24 วัน ขึ้นอยู่กับประเภทสินค้าและรอบขนส่ง",
      },
      {
        q: "สินค้าเสียหายระหว่างขนส่งทำอย่างไร?",
        a: "เรามีประกันสินค้า หากสินค้าเสียหายระหว่างขนส่ง เราคืนเงินเต็มจำนวน",
      },
      {
        q: "รับสั่งสินค้าจากแพลตฟอร์มไหนบ้าง?",
        a: "เรารับสั่งสินค้าจากหลากหลายแหล่ง ครอบคลุมทุกเว็บไซต์และช่องทางการสั่งซื้อ",
      },
    ];
    return (
      <section className="py-5">
        <div className="container">
          <h2 className="fw-bold text-center mb-4">FAQ</h2>
          <div className="row">
            {faq.map((r, i) => (
              <div
                key={i}
                className="col-12 col-md-6 slide-up mb-3"
                style={{ minHeight: "100%" }}
              >
                <div
                  className="bg-white p-4 shadow-sm rounded-4 d-flex"
                  style={{ minHeight: "100%" }}
                >
                  <div className="wpx-30 hpx-30 bg-orange rounded-3 d-flex align-items-center justify-content-center fw-bold text-white">
                    Q
                  </div>
                  <div className="px-3">
                    <strong>{r.q}</strong>
                    <div className="text-secondary">{r.a}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  contact() {
    return (
      <section className="py-5 bg-light" id="contact">
        <div className="container">
          <h2 className="fw-bold text-center mb-3">
            ติดต่อทีมสนับสนุนและฝ่ายขายของเรา
          </h2>
          <h5 className="text-secondary text-center mb-5">
            เรายินดีรับฟังความต้องการของคุณและให้คำปรึกษาเกี่ยวกับการนำเข้าสินค้า
            และปัญหาทางด้านอื่นๆ
          </h5>
          <div className="row">
            <div className="col-12 col-md-10 col-lg-9 col-xl-8 mb-3 mx-auto">
              <div className="rounded-4 p-3 bg-light shadow-lg mx-auto">
                <div className="p-5">
                  <div className="d-flex mb-4">
                    <div className="wpx-40 hpx-40 bg-orange rounded-3 d-flex align-items-center justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                        fill="#000000"
                        width={24}
                      >
                        <path d="M375 260.8L375 342.1C375 344.2 373.4 345.8 371.3 345.8L358.3 345.8C357 345.8 355.9 345.1 355.3 344.3L318 294L318 342.2C318 344.3 316.4 345.9 314.3 345.9L301.3 345.9C299.2 345.9 297.6 344.3 297.6 342.2L297.6 260.9C297.6 258.8 299.2 257.2 301.3 257.2L314.2 257.2C315.3 257.2 316.6 257.8 317.2 258.8L354.5 309.1L354.5 260.9C354.5 258.8 356.1 257.2 358.2 257.2L371.2 257.2C373.3 257.1 375 258.8 375 260.7L375 260.8zM281.3 257.1L268.3 257.1C266.2 257.1 264.6 258.7 264.6 260.8L264.6 342.1C264.6 344.2 266.2 345.8 268.3 345.8L281.3 345.8C283.4 345.8 285 344.2 285 342.1L285 260.8C285 258.9 283.4 257.1 281.3 257.1zM249.9 325.2L214.3 325.2L214.3 260.8C214.3 258.7 212.7 257.1 210.6 257.1L197.6 257.1C195.5 257.1 193.9 258.7 193.9 260.8L193.9 342.1C193.9 343.1 194.2 343.9 194.9 344.6C195.6 345.2 196.4 345.6 197.4 345.6L249.6 345.6C251.7 345.6 253.3 344 253.3 341.9L253.3 328.9C253.3 327 251.7 325.2 249.8 325.2L249.9 325.2zM443.6 257.1L391.3 257.1C389.4 257.1 387.6 258.7 387.6 260.8L387.6 342.1C387.6 344 389.2 345.8 391.3 345.8L443.5 345.8C445.6 345.8 447.2 344.2 447.2 342.1L447.2 329C447.2 326.9 445.6 325.3 443.5 325.3L408 325.3L408 311.7L443.5 311.7C445.6 311.7 447.2 310.1 447.2 308L447.2 294.9C447.2 292.8 445.6 291.2 443.5 291.2L408 291.2L408 277.5L443.5 277.5C445.6 277.5 447.2 275.9 447.2 273.8L447.2 260.8C447.1 258.9 445.5 257.1 443.5 257.1L443.6 257.1zM576 157.4L576 483.4C575.9 534.6 533.9 576.1 482.6 576L156.6 576C105.4 575.9 63.9 533.8 64 482.6L64 156.6C64.1 105.4 106.2 63.9 157.4 64L483.4 64C534.6 64.1 576.1 106.1 576 157.4zM505.6 297.5C505.6 214.1 421.9 146.2 319.2 146.2C216.5 146.2 132.8 214.1 132.8 297.5C132.8 372.2 199.1 434.9 288.7 446.8C310.5 451.5 308 459.5 303.1 488.9C302.3 493.6 299.3 507.3 319.2 499C339.1 490.7 426.5 435.8 465.7 390.8C492.7 361.1 505.6 331 505.6 297.7L505.6 297.5z" />
                      </svg>
                    </div>
                    <div className="ps-3">
                      <h5 className="fw-bold mb-0">Line OA</h5>
                      <a
                        className="text-secondary text-decoration-none"
                        href="https://page.line.biz/account/@488dmsci"
                      >
                        @488dmsci
                      </a>
                    </div>
                  </div>
                  <div className="d-flex mb-4">
                    <div className="wpx-40 hpx-40 bg-orange rounded-3 d-flex align-items-center justify-content-center">
                      <h5 className="icon">{"\uf0e0"}</h5>
                    </div>
                    <div className="ps-3">
                      <h5 className="fw-bold mb-0">อีเมล</h5>
                      <a
                        className="text-secondary text-decoration-none"
                        href="mailto:support@zenithlink.tech"
                      >
                        support@zenithlink.tech
                      </a>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="wpx-40 hpx-40 bg-orange rounded-3 d-flex align-items-center justify-content-center">
                      <h5 className="icon">{"\uf017"}</h5>
                    </div>
                    <div className="ps-3">
                      <h5 className="fw-bold mb-0">เวลาทำการ</h5>
                      <div className="text-secondary">
                        จันทร์ - ศุกร์: 08:00 - 22:00
                      </div>
                      <div className="text-secondary">เสาร์: 9:00 - 20:00</div>
                      <div className="text-secondary">อาทิตย์: ปิดทำการ</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  cta() {
    return (
      <section className="py-5 bg-orange text-center">
        <div className="container zoom-in">
          <h2 className="fw-bold mb-3">พร้อมเริ่มธุรกิจนำเข้าสินค้าจากจีน?</h2>
          <Link to="/login" className="btn btn-dark btn-lg">
            เริ่มสั่งสินค้าเลย
          </Link>
        </div>
      </section>
    );
  }
}

export default Index;
